import { idtype, image } from "querypieces";

export default `
  ...on articleBuilder_imageCaption_BlockType {
    ${idtype}
    ${image}
    caption
  }
`;
